/* Interaction layer: sticky buy bar, hover prefetch, scroll-aware header. */
(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  async function refreshDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const res = await fetch(window.Shopify.routes.root + '?section_id=cart-drawer');
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    ['.drawer__inner', '.cart-drawer__form', '.drawer__footer'].forEach(function (sel) {
      const from = doc.querySelector(sel);
      const to = drawer.querySelector(sel);
      if (from && to) to.innerHTML = from.innerHTML;
    });
    drawer.classList.remove('is-empty');
    if (typeof drawer.open === 'function') drawer.open();
    else drawer.classList.add('active');
  }

  /* ---------- 1. Sticky buy bar ---------- */
  const bar = document.querySelector('[data-sg-sticky]');
  const mainForm = document.querySelector('.product-form__buttons') || document.querySelector('.product-form__submit');

  if (bar && mainForm && 'IntersectionObserver' in window) {
    bar.hidden = false;

    new IntersectionObserver(
      function (entries) {
        bar.dataset.visible = entries[0].isIntersecting ? 'false' : 'true';
      },
      { rootMargin: '0px 0px -40px 0px', threshold: 0 }
    ).observe(mainForm);

    const addBtn = bar.querySelector('[data-sg-sticky-add]');
    if (addBtn) {
      addBtn.addEventListener('click', async function () {
        const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
        const id = idInput && idInput.value;
        if (!id) {
          const submit = document.querySelector('.product-form__submit');
          if (submit) submit.click();
          return;
        }

        const label = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        try {
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
          });
          addBtn.dataset.state = 'done';
          addBtn.textContent = 'Added';
          await refreshDrawer();
          setTimeout(function () {
            addBtn.dataset.state = '';
            addBtn.textContent = label;
          }, 1500);
        } catch (e) {
          addBtn.textContent = label;
        }
      });
    }

    /* keep the bar's price in step with the selected variant */
    const priceEl = bar.querySelector('[data-sg-sticky-price]');
    const livePrice = document.querySelector('.product__info-container .price-item--regular');
    if (priceEl && livePrice && 'MutationObserver' in window) {
      new MutationObserver(function () {
        priceEl.textContent = livePrice.textContent.trim();
      }).observe(livePrice, { childList: true, characterData: true, subtree: true });
    }
  }

  /* ---------- 2. Prefetch product pages on hover intent ---------- */
  const prefetched = new Set();
  let hoverTimer;

  document.addEventListener('mouseover', function (e) {
    const link = e.target.closest('a[href*="/products/"]');
    if (!link || prefetched.has(link.href)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () {
      const l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = link.href;
      document.head.appendChild(l);
      prefetched.add(link.href);
    }, 120);
  });

  document.addEventListener('mouseout', function () {
    clearTimeout(hoverTimer);
  });


  /* ---------- 4. Shopify's preview bar overlaps bottom-anchored UI ----------
     In theme preview the bar is a full-viewport iframe; its strip sits over the
     cart drawer's checkout button and the sticky buy bar. Lift them clear. */
  function flagPreviewBar() {
    const bar = document.querySelector('iframe[src*="preview-bar"], #PreviewBarInjector');
    document.documentElement.classList.toggle('sg-previewing', !!bar);
  }
  flagPreviewBar();
  setTimeout(flagPreviewBar, 1500);
  setTimeout(flagPreviewBar, 4000);

  /* ---------- 3. Header: hide on scroll down, reveal on scroll up ---------- */
  const header = document.querySelector('sticky-header') || document.querySelector('.section-header');
  if (header && !reduce) {
    let last = window.scrollY;
    let ticking = false;

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          const y = window.scrollY;
          header.dataset.sgHidden = y > 140 && y > last ? 'true' : 'false';
          last = y;
          ticking = false;
        });
      },
      { passive: true }
    );
  }
})();

/* ─────────────────────────────────────────────────────────────
   Option-aware gallery.

   A merged product carries every combination's photos at once, so choosing
   Single used to leave photos of the pair on screen. Each photo's alt text
   carries the values it belongs to after an en dash:

       Fluted Oversized Nightstand – Blue – Set of 2
       Fluted Oversized Nightstand – Blue            (shared: shows for both)

   A photo is hidden when it names a value of an option and that value is not
   the one selected. Photos naming nothing (size charts, detail shots) always
   stay.

   Matching is EXACT against those dash-separated segments, never a substring
   search of the whole alt. Substring matching produced two separate bugs:
   "Light Natural" matched plain "natural" and blanked the gallery, and a
   product whose title contains a colour ("White 7-Drawer Dresser") could hide
   its own black photos. Comparing whole segments removes both.
   ───────────────────────────────────────────────────────────── */
(function () {
  function optionState(scope) {
    var inputs = scope.querySelectorAll('variant-selects input[type="radio"], variant-selects option');
    var byName = {};
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      var name = el.dataset ? el.dataset.optionName : null;
      if (!name) continue;
      var o = byName[name] || (byName[name] = { values: [], picked: null });
      var val = (el.value || '').trim().toLowerCase();
      if (val && o.values.indexOf(val) === -1) o.values.push(val);
      var on = el.tagName === 'OPTION' ? el.selected : el.checked;
      if (on) o.picked = val;
    }
    return byName;
  }

  /* the values this photo declares, taken from the alt's dash-separated tail */
  function tokensOf(alt) {
    var parts = alt.split('–');
    var out = [];
    for (var i = 1; i < parts.length; i++) {
      var t = parts[i].trim().toLowerCase();
      if (t) out.push(t);
    }
    return out;
  }

  function apply() {
    var scope = document.querySelector('.product') || document;
    var opts = optionState(scope);
    var names = Object.keys(opts);
    if (!names.length) return;

    var items = scope.querySelectorAll('.product__media-item, .thumbnail-list__item');
    var firstVisible = null;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var img = item.querySelector('img');
      var tokens = tokensOf((img && img.getAttribute('alt')) || '');

      var hide = false;
      for (var n = 0; n < names.length && !hide; n++) {
        var o = opts[names[n]];
        if (!o.picked || o.values.length < 2) continue;

        // does this photo declare any value of this option?
        var declares = false;
        for (var v = 0; v < o.values.length; v++) {
          if (tokens.indexOf(o.values[v]) !== -1) { declares = true; break; }
        }
        if (declares && tokens.indexOf(o.picked) === -1) hide = true;
      }

      item.hidden = hide;
      item.classList.toggle('sg-media-hidden', hide);
      if (!hide && !firstVisible && item.classList.contains('product__media-item')) firstVisible = item;
    }

    // if the slider was parked on a photo we just hid, move it to a visible one
    if (firstVisible) {
      var active = scope.querySelector('.product__media-item:not([hidden]).is-active');
      if (!active) firstVisible.classList.add('is-active');
    }
  }

  function schedule() {
    apply();
    // Dawn re-renders the media column after a variant change; re-apply once it has
    setTimeout(apply, 60);
    setTimeout(apply, 350);
    setTimeout(apply, 900);
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects')) schedule();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();

/* Marks the sticky header once the page has moved under it, so the divider
   and shadow only appear when there is content to separate from. */
(function () {
  var bar = document.querySelector('.header-wrapper');
  if (!bar) return;
  var ticking = false;
  function sync() {
    bar.classList.toggle('sg-stuck', window.scrollY > 4);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(sync);
  }, { passive: true });
  sync();
})();

/* Shopify's <shopify-account> popover renders inside a shadow root and, on this
   store, paints no background at all, so "Sign in or create account" appeared as
   bare text floating over the hero photo. Setting the documented
   --shopify-account-color-* custom properties from the page did not resolve
   inside the shadow tree, so the stylesheet is adopted into the shadow root
   itself. Scoped to background/border only; if Shopify renames these internals
   the rule simply stops matching and nothing breaks. */
(function () {
  var PATCH = [
    '.dialog, .account, .account__header, .account__body, .account__footer {',
    '  background-color: #fff !important;',
    '}',
    '.dialog {',
    '  border: 1px solid #e5e1d8 !important;',
    '  border-radius: 14px;',
    '  box-shadow: 0 20px 48px rgba(20, 18, 15, 0.18);',
    '  overflow: hidden;',
    '}',
  ].join('\n');

  function patch(host) {
    var sr = host && host.shadowRoot;
    if (!sr || sr.querySelector('style[data-sg-account]')) return false;
    var s = document.createElement('style');
    s.setAttribute('data-sg-account', '');
    s.textContent = PATCH;
    sr.appendChild(s);
    return true;
  }

  function tryPatch() {
    var host = document.querySelector('shopify-account');
    return host ? patch(host) : false;
  }

  if (!tryPatch()) {
    // the element upgrades asynchronously, so watch briefly rather than poll forever
    var tries = 0;
    var timer = setInterval(function () {
      if (tryPatch() || ++tries > 40) clearInterval(timer);
    }, 250);
  }
})();

/* ─────────────────────────────────────────────────────────────
   Choosing a variant on the product card.

   The card used to say "Choose options" and send people to the product page
   to pick a colour. Now the values sit on the card: tap one and the photo,
   the price and the Add to cart button all follow it.

   Why the shape is decided here rather than in Liquid: whether a set of
   values is really a set of COLOURS is a judgement about words. "Black" and
   "Gray" are colours and deserve dots. "White in the box" and "Antique White
   Assembled" are packing choices that happen to contain a colour word — two
   identical white dots would tell a shopper nothing and hide a $70 price
   difference. So a group only becomes dots when every value resolves to a
   distinct colour on its own.
   ───────────────────────────────────────────────────────────── */
(function () {
  var COLORS = {
    black: '#1c1c1c',
    white: '#f4f2ee',
    grey: '#8d8d8d',
    gray: '#8d8d8d',
    charcoal: '#3a3a3a',
    brown: '#6b4b32',
    'rustic brown': '#8a5a3b',
    'warm brown': '#8b6141',
    'mix brown': '#7a5540',
    walnut: '#5c4033',
    'dark walnut': '#4a3728',
    oak: '#c8a678',
    'light oak': '#dcc09a',
    honey: '#c98f4a',
    sand: '#ded2bb',
    natural: '#d8bd95',
    /* the catalogue carries two different wood tones under similar names:
       a mid oak from one supplier and a pale blonde from another. Giving them
       genuinely different swatches is the whole point of showing a dot. */
    'light natural': '#ecdcc0',
    'natural wood': '#d8bd95',
    'natural bamboo': '#d8b774',
    bamboo: '#d8b774',
    'antique white': '#efe6d5',
    'distressed white': '#eee8dd',
    /* the catalogue's own finish names, not general colours: "two-tone" is
       the cream-over-taupe gloss, "white-silver" the white with a chrome
       band. Both split into two discs rather than pretending to be flat. */
    'two-tone': '#e8e0d2',
    'two tone': '#e8e0d2',
    beige: '#ddd2c0',
    cream: '#efe7d8',
    ivory: '#f2ece0',
    navy: '#22314f',
    blue: '#3c5a86',
    green: '#4f6b52',
    sage: '#9aa88f',
    pink: '#e3bfc0',
    red: '#9c3b34',
    gold: '#c2a24c',
    silver: '#c7c7c7',
    taupe: '#b3a394',
    espresso: '#3b2a20',
  };

  /* A value becomes a dot only if the WHOLE value is a colour name, give or
     take a finish word like "high gloss".

     Anything naming assembly or packaging is refused outright. "Antique White
     Assembled" and "Antique White In Box" are the same colour at a $70
     difference; drawing them as two identical circles would hide the only
     thing that separates them. Those rows keep their words on purpose. */
  function toColor(raw) {
    var v = String(raw || '').trim().toLowerCase().replace(/\s+/g, ' ');
    if (/assembled|in box|in the box|flat.?pack/.test(v)) return null;

    if (COLORS[v]) return [COLORS[v]];

    // strip a finish word from either end: "high gloss white", "white high gloss"
    var bare = v
      .replace(/^(high gloss|matte|glossy|solid|classic|modern)\s+/, '')
      .replace(/\s+(high gloss|gloss|matte|glossy|finish)$/, '');
    if (COLORS[bare]) return [COLORS[bare]];

    // "white-silver" and the like get a split disc
    var pair = bare.split(/\s*[-\/]\s*/);
    if (pair.length === 2 && COLORS[pair[0]] && COLORS[pair[1]]) {
      return [COLORS[pair[0]], COLORS[pair[1]]];
    }
    return null;
  }

  /* A row of values becomes dots only when EVERY value in that row is its own
     distinct colour. One wordy value ("Set of 2", "In Box") keeps the whole
     row as pills, because a half-dots half-pills row reads as broken. */
  /* Three shapes, in order of preference:

     1. photo swatches — a thumbnail of the actual variant. Preferred for
        everything, because it can never be wrong: it shows the piece rather
        than a guess at what its colour name means. A hand-kept colour list
        goes stale the moment a supplier invents a finish, and that failure is
        silent — the row quietly turns into words.
     2. colour dots  — no photo on the variant, but every value is its own
        distinct colour, so the colour can stand in for the picture.
     3. text pills — neither, so the words have to do the work. */
  /* Options that are not about appearance stay as words, whatever photos are
     available. "Set of 2" and "Single" are the same piece of furniture, so two
     thumbnails of it are identical and tell a shopper nothing about how many
     they are buying — the quantity only exists in the words. Same for sizes
     and assembly choices. A swatch answers "what does it look like"; it
     cannot answer "how many" or "how big". */
  var WORDS_ONLY = /\b(set|size|sizes|qty|quantity|pack|count|length|width|style|assembly|assembled)\b/i;

  function styleRow(row) {
    var btns = [].slice.call(row.querySelectorAll('[data-sg-swatch]'));
    if (!btns.length) return;

    var optName = row.getAttribute('aria-label') || '';
    if (WORDS_ONLY.test(optName)) return;

    if (btns.every(function (b) { return !!b.querySelector('.sgcard__swatch-img'); })) {
      btns.forEach(function (b) { b.classList.add('sgcard__swatch--photo'); });
      return;
    }

    var colors = btns.map(function (b) { return toColor(b.getAttribute('data-value')); });
    if (!colors.every(Boolean)) return;

    // two values resolving to the same colour is not a choice anyone can see
    var seen = {};
    var distinct = colors.every(function (c) {
      var k = c.join('|');
      if (seen[k]) return false;
      seen[k] = 1;
      return true;
    });
    if (!distinct) return;

    btns.forEach(function (b, i) {
      b.classList.add('sgcard__swatch--dot');
      b.style.setProperty('--sg-swatch', colors[i][0]);
      if (colors[i][1]) {
        b.classList.add('sgcard__swatch--split');
        b.style.setProperty('--sg-swatch-2', colors[i][1]);
      }
    });
  }

  function variantsOf(card) {
    if (card.__sgVariants) return card.__sgVariants;
    var tag = card.querySelector('[data-sg-variants]');
    if (!tag) return null;
    try { card.__sgVariants = JSON.parse(tag.textContent); } catch (e) { card.__sgVariants = null; }
    return card.__sgVariants;
  }

  function selection(card) {
    var picked = [];
    card.querySelectorAll('[data-sg-swatch-row]').forEach(function (row) {
      var on = row.querySelector('[aria-pressed="true"]');
      picked[Number(row.getAttribute('data-option-index'))] = on ? on.getAttribute('data-value') : null;
    });
    return picked;
  }

  function match(variants, picked) {
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < picked.length; j++) {
        if (picked[j] != null && variants[i].options[j] !== picked[j]) { ok = false; break; }
      }
      if (ok) return variants[i];
    }
    return null;
  }

  /* For each swatch, work out the variant you would land on if you picked it
     while leaving the other options as they are. That answers two questions
     at once:

     - is it in stock? "Set of 2" in white may be gone while Single in white
       is fine, so the greying has to consider the whole combination.
     - which photo should the swatch show? Liquid can only render the first
       variant carrying a value, which is always the Set of 2 one — so after
       choosing Single the colour thumbnails still showed pairs. They are
       repointed here whenever anything changes. */
  function refreshSwatches(card, variants, picked) {
    card.querySelectorAll('[data-sg-swatch]').forEach(function (b) {
      var idx = Number(b.getAttribute('data-option-index'));
      var trial = picked.slice();
      trial[idx] = b.getAttribute('data-value');

      var found = variants.filter(function (v) {
        for (var j = 0; j < trial.length; j++) {
          if (trial[j] != null && v.options[j] !== trial[j]) return false;
        }
        return true;
      });

      if (found.some(function (v) { return v.available; })) b.removeAttribute('data-out');
      else b.setAttribute('data-out', 'true');

      var img = b.querySelector('.sgcard__swatch-img');
      if (!img) return;
      var withImg = found.filter(function (v) { return v.img; })[0];
      if (withImg && img.getAttribute('src') !== withImg.img) {
        img.removeAttribute('srcset');
        img.src = withImg.img;
      }
    });
  }

  function apply(card) {
    var variants = variantsOf(card);
    if (!variants) return;

    var picked = selection(card);
    var v = match(variants, picked);

    refreshSwatches(card, variants, picked);
    if (!v) return;

    var price = card.querySelector('[data-sg-card-price]');
    if (price && v.price) {
      // keep any struck-through compare-at price that follows
      var was = price.querySelector('.sgcard__was');
      price.textContent = v.price;
      if (was) price.appendChild(was);
    }

    var add = card.querySelector('[data-sg-quick-add]');
    if (add) {
      add.setAttribute('data-variant-id', v.id);
      if (v.available) {
        add.removeAttribute('disabled');
        if (add.dataset.state !== 'loading') add.textContent = 'Add to cart';
      } else {
        add.textContent = 'Sold out';
        add.setAttribute('disabled', '');
      }
    }

    swapImage(card.querySelector('.sgcard__img--main'), v.img);
  }

  /* Swap without a blank frame.

     Assigning .src directly clears the element while the new file downloads,
     so the card flashes empty on every tap. Loading into a detached Image
     first means the picture is decoded and in cache before it goes on screen,
     and the old photo stays put until then. The guard handles fast tapping:
     if a newer choice has been made while this one was loading, it is dropped
     rather than overwriting the newer picture. */
  function swapImage(main, url) {
    if (!main || !url) return;
    if (main.dataset.sgShown === url) return;
    main.dataset.sgShown = url;

    var pre = new Image();
    pre.onload = function () {
      if (main.dataset.sgShown !== url) return;
      // srcset and sizes would otherwise outrank the new src
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = url;
    };
    pre.src = url;
  }

  /* Warm a card's other photos the moment someone reaches for a swatch, so by
     the time they tap, the file is already there. Nothing is fetched for a
     card that is merely scrolled past. */
  function warm(card) {
    if (card.dataset.sgWarm) return;
    card.dataset.sgWarm = '1';
    var variants = variantsOf(card);
    if (!variants) return;
    variants.forEach(function (v) {
      if (v.img) { var i = new Image(); i.src = v.img; }
    });
  }

  ['pointerover', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var row = e.target.closest && e.target.closest('[data-sg-swatch-row]');
      if (row) warm(row.closest('.sgcard'));
    }, { passive: true });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sg-swatch]');
    if (!btn) return;
    // the swatch sits inside the card's link
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('data-out') === 'true') return;

    var row = btn.closest('[data-sg-swatch-row]');
    if (row) {
      row.querySelectorAll('[data-sg-swatch]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
    }
    apply(btn.closest('.sgcard'));
  });

  function init(root) {
    (root || document).querySelectorAll('[data-sg-swatch-row]').forEach(function (row) {
      if (row.dataset.sgReady) return;
      row.dataset.sgReady = '1';
      styleRow(row);
    });
    (root || document).querySelectorAll('.sgcard').forEach(function (card) {
      if (card.querySelector('[data-sg-variants]')) apply(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () { init(); });
})();

/* Favourites.

   The heart is remembered per visitor in localStorage, which is what makes it
   stay filled across pages and repeat visits.

   Reporting it back to the shop is a separate problem, and deliberately NOT
   solved here: localStorage never leaves the shopper's browser, so nothing a
   theme does on its own can show Allen what people saved. Sending it onward
   (a pixel event, a wishlist app) is his decision to make, not a default. */
(function () {
  var KEY = 'sg-favourites';

  function read() {
    try { return JSON.parse(window.localStorage.getItem(KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function write(map) {
    try { window.localStorage.setItem(KEY, JSON.stringify(map)); } catch (e) { /* private mode */ }
  }

  function paint(root) {
    var saved = read();
    (root || document).querySelectorAll('[data-sg-fav]').forEach(function (btn) {
      var on = !!saved[btn.getAttribute('data-product-id')];
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sg-fav]');
    if (!btn) return;
    // the heart sits inside the card's link
    e.preventDefault();
    e.stopPropagation();

    var id = btn.getAttribute('data-product-id');
    var saved = read();
    if (saved[id]) {
      delete saved[id];
      btn.setAttribute('aria-pressed', 'false');
    } else {
      saved[id] = { title: btn.getAttribute('data-product-title') || '', at: Date.now() };
      btn.setAttribute('aria-pressed', 'true');
    }
    write(saved);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paint(); });
  } else {
    paint();
  }

  // sections re-render on variant change and filtering
  document.addEventListener('shopify:section:load', function () { paint(); });
})();
